/* =========================================================================
   Mega drawer (Tekla-style) — tab switching only.
   Open/close, scroll-lock and focus-trap are handled by the theme's generic
   Drawer class (button[data-drawer-toggle][aria-controls="mega-drawer"] +
   #mega-drawer[data-drawer]). This file swaps the active tab panel and keeps the
   burger pointing at the right drawer per viewport.
   Self-contained, idempotent, no dependencies.
   ========================================================================= */
(function () {
  'use strict';

  function initMegaDrawer(root) {
    if (!root || root.dataset.megaInit === 'true') return;
    root.dataset.megaInit = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-mega-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-mega-panel]'));
    if (!tabs.length || !panels.length) return;

    function activate(index) {
      tabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-mega-tab') === String(index);
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-mega-panel') === String(index);
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    tabs.forEach(function (tab) {
      // Switch panels on hover so the tab label itself stays a real link.
      tab.addEventListener('mouseenter', function () {
        activate(tab.getAttribute('data-mega-tab'));
      });
      tab.addEventListener('focus', function () {
        activate(tab.getAttribute('data-mega-tab'));
      });
      // Non-link tabs (buttons) also switch on click.
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-mega-tab'));
      });
      // Keyboard arrow navigation between tabs
      tab.addEventListener('keydown', function (event) {
        var current = tabs.indexOf(tab);
        var next = null;
        if (event.key === 'ArrowRight') next = tabs[current + 1] || tabs[0];
        if (event.key === 'ArrowLeft') next = tabs[current - 1] || tabs[tabs.length - 1];
        if (next) {
          event.preventDefault();
          next.focus();
          activate(next.getAttribute('data-mega-tab'));
        }
      });
    });
  }

  // The existing burger (.js-drawer-open) opens the mega drawer on desktop and
  // the standard nav-drawer on mobile. The theme's generic Drawer reads the
  // button's aria-controls live on each click, so we just keep it in sync with
  // the viewport. Mobile behaviour is left untouched.
  var DESKTOP_MIN = 990;

  function syncBurgerTarget() {
    var burgers = document.querySelectorAll('[data-mega-burger]');
    if (!burgers.length) return;
    var isDesktop = window.innerWidth >= DESKTOP_MIN;
    burgers.forEach(function (burger) {
      burger.setAttribute('aria-controls', isDesktop ? 'mega-drawer' : 'nav-drawer');
    });
  }

  function initBurgerSync() {
    if (!document.querySelector('[data-mega-burger]')) return;
    syncBurgerTarget();
    var raf;
    window.addEventListener('resize', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(syncBurgerTarget);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-mega-drawer]').forEach(initMegaDrawer);
    initBurgerSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init in the theme editor when the header section is reloaded.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-mega-drawer]');
    if (root) initMegaDrawer(root);
    syncBurgerTarget();
  });
})();
